'use client';
import React from 'react';
import ArticleList from './ArticleList';
import ResourceList from './ResourceList';
import { CategoryWithArticlesAndResources } from '@dr-pam/common-components/Services/Server/CategoryService';

type CategoryClientSideProps = {
	category: CategoryWithArticlesAndResources;
	subcategorySlug: string;
	categorySlug: string;
};

export default function CategoryClientSide({ category, subcategorySlug, categorySlug }: CategoryClientSideProps) {
	return (
		<>
			<ArticleList
				articles={category.categoryArticles}
				categorySlug={categorySlug}
				subcategorySlug={subcategorySlug}
			/>
			<ResourceList resources={category.categoryResources} />
		</>
	);
}
